/** Haptics unavailable on web. */
export const HapticFeedbackTypes = {
  impactLight: 'impactLight',
  impactMedium: 'impactMedium',
  impactHeavy: 'impactHeavy',
  notificationSuccess: 'notificationSuccess',
  notificationWarning: 'notificationWarning',
  notificationError: 'notificationError',
  selection: 'selection',
  rigid: 'rigid',
  soft: 'soft',
} as const;

export default {
  trigger: () => {},
};

export const trigger = () => {};
